<template>
    <div :style="onHandleStyle('pc')">
        <div class="body__preview" :style="onHandleStyle('sp')">
            <section
                v-for="(itemLP, idx) in dataBlockPreview"
                :key="idx"
                :id="`${itemLP.key_parent && itemLP.key ? `${itemLP.key_parent}-${itemLP.key}` : itemLP.key}`"
            >
                <div v-if="!blockCustom.includes(itemLP.key)" v-html="itemLP.body_html"></div>
                <!-- block special -->
                <div v-else-if="itemLP.key == 'header_information'">
                    <div v-if="prvForm.status === statusComplete" v-html="prvForm[itemLP.key].html_content_first_view"></div>
                    <!-- <div v-else v-html="prvForm[itemLP.key].html_content_finished_view"></div> -->
                </div>

                <div v-else-if="itemLP.key == 'first_view'">
                    <div v-if="inforBlock(itemLP.key)?.image || inforBlock(itemLP.key)?.finished_image">
                        <div class="image__first_view">
                            <img
                                v-if="prvForm.status !== statusComplete"
                                loading="lazy"
                                :src="inforBlock(itemLP.key).image?.path"
                                :alt="inforBlock(itemLP.key).image?.name"
                            />
                            <div v-else>
                                <img
                                    v-if="inforBlock(itemLP.key).finished_image?.path"
                                    loading="lazy"
                                    :src="inforBlock(itemLP.key).finished_image?.path"
                                    :alt="inforBlock(itemLP.key).finished_image?.name"
                                />
                                <div
                                    v-else
                                    class="d-flex align-items-center justify-content-center"
                                    style="background-color: black; opacity: 0.7; height: 500px"
                                >
                                    <h1 class="text-white font-weight-bold" style="font-size: 24px">このキャンペーンは終了しました。</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else v-html="itemLP.body_html"></div>
                </div>
                <div v-else-if="itemLP.key == 'block_prize'" class="block_prizes" :style="onHandleStyle('block_prize')">
                    <div :class="`box--prize__${inforBlock('prize_settings')?.style?.id}`">
                        <div v-if="inforBlock('prize_settings').title_image?.path" class="mb-5">
                            <img
                                :src="inforBlock('prize_settings').title_image.path"
                                :alt="inforBlock('prize_settings').title_image.path"
                                class="img__title"
                            />
                        </div>
                        <div style="padding-block: 5rem" v-else>
                            <h2
                                v-if="STYLE_SHOW_TITLE.includes(inforBlock('prize_settings')?.style?.id)"
                                class="title-common"
                                :style="onHandleStyle('title_block_prize')"
                            >
                                <span>{{ inforBlock('prize_settings')?.title }}</span>
                            </h2>
                            <h2 v-else class="title-common">
                                <div class="title-eng" :style="onHandleStyle('title_block_prize')">
                                    <span>{{ inforBlock('prize_settings')?.title }}</span>
                                </div>
                                <!-- <div class="title-jp"></div> -->
                            </h2>
                        </div>
                        <div class="list__prize" v-html="itemLP.body_html"></div>
                    </div>
                </div>

                <div v-else-if="itemLP.key == 'block_target_product'" class="block_target_product" :style="onHandleStyle('block_target_product')">
                    <div :class="`__${inforBlock(itemLP.key).style?.id}`">
                        <div class="target_product">
                            <div v-if="inforBlock(itemLP.key).title_image?.path" class="mb-5">
                                <img
                                    :src="inforBlock(itemLP.key).title_image.path"
                                    :alt="inforBlock(itemLP.key).title_image.path"
                                    class="img__title"
                                />
                            </div>
                            <div v-else>
                                <h2
                                    v-if="STYLE_SHOW_TITLE.includes(inforBlock(itemLP.key).style?.id)"
                                    class="title-common"
                                    :style="onHandleStyle('title_block_target_product')"
                                >
                                    <span>{{ inforBlock(itemLP.key).title_block }}</span>
                                </h2>
                                <h2 v-else class="title-common">
                                    <div class="title-eng" :style="onHandleStyle('title_block_target_product')">
                                        <span>{{ inforBlock(itemLP.key).title_block }}</span>
                                    </div>
                                    <!-- <div class="title-jp"></div> -->
                                </h2>
                            </div>
                            <div v-html="itemLP.body_html"></div>
                        </div>
                    </div>
                </div>

                <div
                    v-else-if="itemLP.key == 'block_application_method'"
                    class="block__application--methods"
                    :style="onHandleStyle('block_application_method')"
                >
                    <div :class="`box--methods__${inforBlock(itemLP.key).style?.id}`">
                        <div v-if="inforBlock(itemLP.key).title_image?.path" class="mb-5">
                            <img :src="inforBlock(itemLP.key).title_image.path" :alt="inforBlock(itemLP.key).title_image.path" class="img__title" />
                        </div>
                        <div v-else>
                            <h2
                                v-if="STYLE_SHOW_TITLE.includes(inforBlock(itemLP.key).style?.id)"
                                class="title-common"
                                :style="onHandleStyle('title_block_application_method')"
                            >
                                <span>{{ inforBlock(itemLP.key).title_block }}</span>
                            </h2>
                            <h2 v-else class="title-common">
                                <div class="title-eng" :style="onHandleStyle('title_block_application_method')">
                                    <span>{{ inforBlock(itemLP.key).title_block }}</span>
                                </div>
                                <!-- <div class="title-jp"></div> -->
                            </h2>
                        </div>
                        <div class="list__method" v-html="itemLP.body_html"></div>
                    </div>
                </div>

                <div v-else-if="itemLP.key == 'free_blocks' && inforFreeBlock(itemLP)?.style" class="block_free">
                    <div :class="`box--type__${objBlockFree[itemLP.key_parent].style?.id}`">
                        <h2 class="title" :style="onHandleStyle('title_free_block', objBlockFree[itemLP.key_parent])">
                            <span>{{ objBlockFree[itemLP.key_parent].title }}</span>
                        </h2>
                        <div v-html="itemLP.body_html"></div>
                    </div>
                </div>

                <div
                    v-else-if="itemLP.key == 'block_application_rule'"
                    class="block__application--rule"
                    :style="onHandleStyle('block_application_rule')"
                >
                    <div :class="`box--rule__${inforBlock(itemLP.key).style?.id}`">
                        <h2
                            v-if="STYLE_SHOW_TITLE.includes(inforBlock(itemLP.key).style?.id)"
                            class="title-common"
                            :style="onHandleStyle('title_block_application_rule')"
                        >
                            <span>{{ inforBlock(itemLP.key).title_block }}</span>
                        </h2>
                        <div v-else class="title-common">
                            <h2 class="title-eng" :style="onHandleStyle('title_block_application_rule')">
                                <span>{{ inforBlock(itemLP.key).title_block }}</span>
                            </h2>
                            <!-- <h2 class="title-jp"></h2> -->
                        </div>
                        <div class="content-rule" v-html="itemLP.body_html"></div>
                    </div>
                </div>

                <div v-else-if="itemLP.key == 'block_contact'">
                    <div id="contactBlock" class="block__contact" :style="onHandleStyle('contact')">
                        <div :class="`box--contact__${inforBlock(itemLP.key).style?.id}`">
                            <h2
                                v-if="STYLE_SHOW_TITLE.includes(inforBlock(itemLP.key).style?.id)"
                                class="title-common"
                                :style="onHandleStyle('title-contact')"
                            >
                                <span>{{ inforBlock(itemLP.key).title_block }}</span>
                            </h2>
                            <div v-else class="title-common">
                                <h2 class="title-eng" :style="onHandleStyle('title-contact')">
                                    <span>{{ inforBlock(itemLP.key).title_block }}</span>
                                </h2>
                                <!-- <h2 class="title-jp"></h2> -->
                            </div>
                            <div v-html="itemLP.body_html"></div>
                        </div>
                    </div>
                </div>

                <div
                    v-else-if="itemLP.key == 'block_share'"
                    id="shareBlock"
                    :style="onStyleShare()"
                    class="block_share d-flex justify-content-center"
                >
                    <div v-for="(itemSocial, idx) in activeSocial" :key="`social-${idx}`" class="social__media">
                        <a
                            class="ela--share"
                            :href="onLinkShare(itemSocial)"
                            :target="`${onLinkShare(itemSocial) !== 'javascript:void(0)' ? '_blank' : '_self'}`"
                            :style="`background-color: ${itemSocial.backgroundColor}`"
                        >
                            <img loading="lazy" :src="itemSocial.logo" :alt="itemSocial.logo" />
                        </a>
                    </div>
                </div>

                <div v-else-if="itemLP.key == 'button_blocks' && inforButtonBlock(itemLP)?.style" class="block_button">
                    <button
                        id="button-link"
                        type="button"
                        :class="`button--type__${objBlockButton[itemLP.key_parent].style.name}`"
                        :style="onHandleStyle('block-button', objBlockButton[itemLP.key_parent])"
                        @click="onHandleLinkButton(objBlockButton[itemLP.key_parent].url)"
                        :disabled="prvForm.status === statusComplete"
                    >
                        <p :style="onHandleStyle('title-block-button', objBlockButton[itemLP.key_parent])">
                            {{ objBlockButton[itemLP.key_parent].title_button }}
                        </p>
                        <span class="arrow-right"></span>
                    </button>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import { onHandleSetAttr } from '../../../handlers';
import { SOCIAL_MEDIA_SHARE, STYLE_SHOW_TITLE, LIST_FONT_PAGE } from '../../../constants';
import { landingPageMethods } from '@/state/helpers';

export default {
    name: 'ExportLandingPage',
    components: {},
    props: {
        listBlockLP: {
            type: Array,
            default: () => []
        },
        dataForm: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        activeSocial() {
            return SOCIAL_MEDIA_SHARE?.filter((oBlock) => oBlock.active);
        }
    },
    data() {
        return {
            prvForm: this.dataForm,
            isLoading: true,
            dataBlockPreview: [],
            STYLE_SHOW_TITLE: STYLE_SHOW_TITLE,
            statusComplete: 5,
            objBlockFree: {},
            objBlockButton: {},
            url: 'https://paldia-dev.supenient.vn',
            blockCustom: [
                'first_view',
                'block_share',
                'block_contact',
                'block_application_rule',
                'free_blocks',
                'block_prize',
                'block_target_product',
                'block_application_method',
                'button_blocks',
                'header_information'
            ]
        };
    },
    methods: {
        ...landingPageMethods,

        handleMapPreview() {
            this.dataBlockPreview = this.listBlockLP.filter((oBlock) => oBlock.is_visibled) ?? [];
            SOCIAL_MEDIA_SHARE.forEach((itemSocial) => {
                itemSocial.active = this.prvForm?.block_share?.platform[itemSocial.key].active ?? false;
            });
            onHandleSetAttr(this.prvForm.style_setting);
        },

        onStyleShare() {
            let { background_image, background_color, is_repeat } = this.prvForm?.block_share;
            return `background-color: ${background_color ?? ''};
                    background-image: url(${background_image?.path ?? ''});
                    background-repeat: ${is_repeat ? 'repeat' : 'no-repeat'};
                    overflow: hidden;
                    background-blend-mode: multiply;`;
        },

        onLinkShare(shareUrl) {
            let { block_share } = this.prvForm;
            return block_share.platform[shareUrl.key].url || 'javascript:void(0)';
        },

        onHandleLink() {
            const linkButton = document.getElementById('button-link');
            if (!linkButton) return;
            linkButton.addEventListener('click', function (e) {
                const href = this.getAttribute('href');
                if (!href || href === '#') {
                    e.preventDefault();
                }
            });
        },

        onHandleStyle(type, paramFreeBlock = null) {
            let { block_contact, block_application_rule, prize_settings, block_target_product, block_application_method } = this.prvForm;
            let { pc, sp } = this.prvForm?.style_setting;
            switch (type) {
                case 'pc':
                    return `background-color: ${pc.background_color || '#ffffff'};
                            background-image: url(${pc.background_image?.path || ''});
                            background-repeat: ${pc.is_repeat ? 'repeat' : 'no-repeat'};
                            overflow: hidden;
                            background-blend-mode: multiply;`;
                case 'sp':
                    return `background-color: ${sp.background_color || '#ffffff'};
                            background-image: url(${sp.background_image?.path || ''});
                            background-repeat: ${sp.is_repeat ? 'repeat' : 'no-repeat'};`;
                case 'contact':
                    return `background-color: ${block_contact.background_color ?? ''};
                            background-image: url(${block_contact.background_image?.path ?? ''});
                            background-repeat: ${block_contact.is_repeat ? 'repeat' : 'no-repeat'};
                            min-height: 300px;`;
                case 'title-contact':
                    return `background: ${block_contact.background_title ?? ''};
                            color:  ${block_contact.color_title ?? ''};
                            font-size: ${block_contact.size_title}px;`;
                case 'block_application_rule':
                    return `background-color: ${block_application_rule.background_color ?? ''};
                            background-image: url(${block_application_rule.background_image?.path ?? ''});
                            background-repeat: ${block_application_rule.is_repeat ? 'repeat' : 'no-repeat'};
                            min-height: 300px;
                            overflow: hidden;
                            background-blend-mode: multiply;`;
                case 'title_block_application_rule':
                    return `background: ${block_application_rule.background_title ?? ''};
                            color:  ${block_application_rule.color_title ?? ''};
                            font-size: ${block_application_rule.size_title}px;`;
                case 'title_free_block':
                    return `background: ${paramFreeBlock.background_title ?? ''};
                            color:  ${paramFreeBlock.color_title ?? ''};
                            font-size: ${paramFreeBlock.size_title}px;`;
                case 'block_prize':
                    return `background-color: ${prize_settings.background.color ?? ''};
                            background-image: url(${prize_settings.background.image?.path});
                            background-repeat: ${prize_settings.is_repeat ? 'repeat' : 'no-repeat'};`;
                case 'title_block_prize':
                    return `background: ${prize_settings.background_title ?? ''};
                            color:  ${prize_settings.color_title ?? ''};
                            font-size: ${prize_settings.size_title}px;`;
                case 'block_target_product':
                    return `background-color: ${block_target_product?.background_color ?? ''};
                            background-image: url(${block_target_product?.background_image?.path ?? ''});
                            background-repeat: ${block_target_product?.is_repeat ? 'repeat' : 'no-repeat'};`;
                case 'title_block_target_product':
                    return `background: ${block_target_product?.background_title ?? ''};
                            color:  ${block_target_product?.color_title ?? ''};
                            font-size: ${block_target_product?.size_title}px;`;
                case 'block_application_method':
                    return `background-color: ${block_application_method?.background_color ?? ''};
                            background-image: url(${block_application_method?.background_image?.path ?? ''});
                            background-repeat: ${block_application_method?.is_repeat ? 'repeat' : 'no-repeat'};`;
                case 'title_block_application_method':
                    return `background: ${block_application_method?.background_title ?? ''};
                            color:  ${block_application_method?.color_title ?? ''};
                            font-size: ${block_application_method?.size_title}px;`;
                case 'block-button':
                    return `color: ${paramFreeBlock?.color ?? ''};
                            font-family:${LIST_FONT_PAGE.find((itemFont) => itemFont.id == paramFreeBlock?.font_button)?.property_style?.fontFamily ?? ''};
                            background-color: ${paramFreeBlock?.background_color ?? ''};
                            box-shadow: 0 8px 0 ${paramFreeBlock?.background_color ?? ''}; `;
                case 'title-block-button':
                    return `font-family:${LIST_FONT_PAGE.find((itemFont) => itemFont.id == paramFreeBlock?.font_button)?.property_style?.fontFamily ?? ''};`;
            }
        },

        inforFreeBlock(itemKey) {
            const foundBlock = this.prvForm[itemKey.key]?.find((fdt) => fdt.key_parent == itemKey.key_parent);
            this.objBlockFree[itemKey.key_parent] = foundBlock;
            return foundBlock;
        },

        inforButtonBlock(itemKey) {
            const foundBlock = this.prvForm[itemKey.key]?.find((fdt) => fdt.key_parent == itemKey.key_parent);
            this.objBlockButton[itemKey.key_parent] = foundBlock;
            return foundBlock;
        },

        inforBlock(itemKey) {
            return this.prvForm[itemKey];
        },

        onHandleLinkButton(link) {
            if (!link) return '';
            window.open(link, '_blank');
        }
    },
    mounted() {
        this.handleMapPreview();
    },
    updated() {
        this.onHandleLink();
    }
};
</script>

<style lang="scss" scoped></style>
